export default __webpack_public_path__ + "static/media/process-download-mobile.8ea0725b.svg";